import OnlineAppComponent from "../lib/online_app_component";
import {OnlineAppRootConfig} from "./online_app_root/online_app_root";

export const OnlineAppNavToggleConfig = {
    componentTypeKey: 'OnlineAppNavToggle',
    baseHtmlClass: 'nav__toggle',
    selector: '.nav__toggle'
};

export class OnlineAppNavToggle extends OnlineAppComponent {

    static get config() {
        return OnlineAppNavToggleConfig;
    }

    constructor(id_or_element, onlineApp, onlineAppNav) {
        super(id_or_element, onlineApp, OnlineAppNavToggleConfig);
        this.nav = onlineAppNav;
        this.render();
    }

    isModalMode() {
        const modeCode = this.readStateMachineValue('modal');
        return (modeCode === OnlineAppRootConfig.modalModeCode) || (modeCode === OnlineAppRootConfig.oversizeModalModeCode);
    }

    render() {
        this.swapHtmlClassStates(this.isModalMode(), 'modal', 'not_modal');
    }

}